import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase/init';
import type { User } from '../../types';
import { getRestaurantId } from '../../utils/restaurant';

interface EnsureCustomerProfileResult {
  success: boolean;
  created: boolean;
  linked: boolean;
  profile: User;
}

interface EnsureCustomerProfileInput {
  name?: string;
  email?: string;
  phoneNumber?: string;
}

const ensureCustomerProfileCallable = httpsCallable<
  { restaurantId: string; name?: string; email?: string; phoneNumber?: string },
  EnsureCustomerProfileResult
>(functions, 'ensureCustomerProfile');

export const customerProfileService = {
  async ensure(input: EnsureCustomerProfileInput = {}): Promise<User> {
    const response = await ensureCustomerProfileCallable({
      restaurantId: getRestaurantId(),
      name: input.name,
      email: input.email,
      phoneNumber: input.phoneNumber,
    });
    return response.data.profile;
  },
};
